import React, { useState, useEffect } from 'react'
import './SingleTravel.min.css'
import { AiFillDelete, AiFillEdit, AiOutlineClose } from 'react-icons/ai'
import axios from 'axios';
import { Travel } from '../TravelsPlanned/model'
import Swal from 'sweetalert2'
import { ipAddress } from '../../ipAddress';

interface Cost {
  id: number;
  name: string;
  isDone: number;
  kwota: number;
}
interface Props {
  costs: Cost[];
  setCosts: React.Dispatch<React.SetStateAction<Cost[]>>;
  money: Cost;
  travel: Travel;
}

const CostsTravel: React.FC<Props> = ({ costs, setCosts, money, travel }) => {
  const [edit, setEdit] = useState<boolean>(false);
  const [editThing, setEditThing] = useState<string>(money.name);
  const [editCost, setEditCost] = useState<number>(money.kwota);
  const [addOption, setAddOption] = useState<boolean>(false);

  const handleChange = (id: number, isDone: number) => {
    if (isDone == 1) {
      isDone = 0
    } else {
      isDone = 1
    }
    axios.post(ipAddress + '/doneCostTravel', {
      id: id,
      isDone: isDone,

    })
    // setCosts(costs.map((cost) => cost.id == id ? {...cost, isDone: 0}: cost ))

  };

  const handleDelete = (id: number, name: string) => {
    Swal.fire({
      title: name,
      text: "Czy jesteś pewien, że chcesz usunąc ten element ?",
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
      heightAuto: false,

    }).then((result) => {
      if (result.isConfirmed) {
        axios.post(ipAddress + '/deleteCostTravel', {
          id: id,
        })
        // setCosts(costs.filter((cost) => (cost.id !== id) ))
      }
    })

  }

 

 

  const handleEdit = (e: React.FormEvent, id: number) => {
    setAddOption(false);

    e.preventDefault();
    axios.post(ipAddress + "/editCostTravel", {
      nameCost: editThing,
      cost: editCost,
      id: id,

    })
      .then((response) => {

      })
      .catch(function (error) {
        console.log("error!")

      })

    setEdit(false)
  }

  const close = () => {
    setEdit(false);
    setEditThing(money.name);
    setEditCost(money.kwota);
    
    
    
  }


  const resize = () => {
    let element = document.getElementById("textAreaEditCost")
    element.style.height = "5px";
    element.style.height = (element.scrollHeight) + "px";
  }
  



  return (
    <div className='list'>
      <div className='done'>

        {money.isDone == 1 ? (

          <span>
            <input type='checkbox' checked={true}
              onChange={() => handleChange(money.id, money.isDone)}
            ></input>
            <s className='text'> {money.name} {money.kwota} zł</s>
          </span>


        ) : (
          <span>
            <input type='checkbox' checked={false}
              onChange={() => handleChange(money.id, money.isDone)}
            ></input>
            <div className='icons'>
            <span className='edit' onClick={() => setEdit(true)} ><AiFillEdit /></span>
            <span className='delete' onClick={() => handleDelete(money.id, money.name)} ><AiFillDelete /></span>
            </div>
            <span className='text'> {money.name} {money.kwota} zł</span>
           
          </span>
        )
        }

      

      </div>


      {edit ? (
        <form className='editThing' onSubmit={(e) => { handleEdit(e, money.id) }}>

          <button type='button' id='close' onClick={() => close()} >X</button>
          <p>Edytuj koszt wyjazdu</p>
          <div className='thing'>

            <textarea id='textAreaEditCost'
              rows={4}
              value={editThing}
              onChange={(e) => (resize(), setEditThing(e.target.value))}
              onClick={() => resize()}
            ></textarea>
          </div>
          <div className='edit'>
            <label htmlFor="edit">Kwota: </label>
            <input type='number'
              value={editCost}
              onChange={(e) => setEditCost(e.target.valueAsNumber)}
            ></input>
            <span> zł</span>
          </div>
          <button type='submit' id='submit'>OK</button>
        </form>
      ) : (
        <span></span>
      )
      }

    </div>


  )
}

export default CostsTravel;